export const EVENTS_DISASTERS_TYPES_EMS = "ems";
export const EVENTS_DISASTERS_TYPES_EARTHQUAKES = "earthquakes";
export const EVENTS_DISASTERS_TYPES_FLOODS = "floods";
export const EVENTS_DISASTERS_TYPES_VOLCANOES = "volcanoes";
export const EVENTS_DISASTERS_TYPES = {
  ems: EVENTS_DISASTERS_TYPES_EMS,
  earthquakes: EVENTS_DISASTERS_TYPES_EARTHQUAKES,
  floods: EVENTS_DISASTERS_TYPES_FLOODS,
  volcanoes: EVENTS_DISASTERS_TYPES_VOLCANOES,
};
export const EVENTS_AI_EMOTIONS = [
  "anger",
  "disgust",
  "fear",
  "joy",
  "sadness",
  "surprise",
];
